<template>
  <div v-if="img && img.phone">
    <img :src="img.phone" style="width: 100%;" @load="onLoad" />
  </div>
</template>
<script>
import {getImg} from '@/api/server/acting'
import {getItem, saveItem} from '@/utils/storage'
export default {
  name: 'ContactComponent',
  data () {
    return {
        contactImg: '../../static/images/contact.jpeg',
        img: {}
    }
  },
  computed: {
  },
  methods: {
    onLoad () {
      this.$emit('onShow', 'contact')
    },
    _getPic (cid) {
      let query = {
        cid: cid
      }
      picDetail(query).then( (res) => {
        if (res.code === 200) {
          this.contactImg = res.data.img
        }
      })
    },
    // 获取代理广告
    _getActing (phone) {
      let query = {
        phone: phone
      }
      getImg(query).then( (res) => {
        if (res.code === 200) {
          this.img = res.data
          saveItem('acting-phone', phone)
        }
      })
    },
    _reset () {
      let phone = this.$route.query.phone
      if (phone) {
        this._getActing(phone)
      } else {
        phone = getItem('acting-phone')
        this._getActing(phone)
      }
    }
  },
  mounted: function () {
    this._reset()
  }

}
</script>
<style lang="scss" scoped>
.contact {
  img {
    max-width: 100%;
  }
}
</style>